var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E55873"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8706_27137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9813 22H28.5C28.8978 22 29.2794 21.842 29.5607 21.5607C29.842 21.2794 30 20.8978 30 20.5V14.5C30 14.1022 29.842 13.7206 29.5607 13.4393C29.2794 13.158 28.8978 13 28.5 13H18.5C18.1022 13 17.7206 13.158 17.4393 13.4393C17.158 13.7206 17 14.1022 17 14.5V21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 15.5,
    r: 0.75,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 19.5,
    r: 0.75,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4395 16.4421C22.7212 16.163 23.1019 16.0069 23.4985 16.0078C23.895 16.0087 24.2751 16.1667 24.5555 16.4471C24.8359 16.7275 24.9938 17.1075 24.9948 17.5041C24.9957 17.9006 24.8395 18.2814 24.5605 18.5631",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16H14.7082C14.2425 16 13.7831 16.1084 13.3666 16.3167L12.7814 16.6093C12.2711 16.8644 11.8441 17.2598 11.5506 17.749L10 20.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 28.9996L16.7619 26.9176C17.5661 26.627 18.256 26.0864 18.7304 25.375L21.7233 20.887C21.9344 20.5704 22.0293 20.1905 21.9918 19.8118C21.9543 19.4332 21.7868 19.0792 21.5178 18.8101C21.2092 18.5016 20.7907 18.3282 20.3542 18.3281C19.9178 18.3281 19.4992 18.5014 19.1906 18.8099L17 20.9996H15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8706_27137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense);
export default __webpack_public_path__ + "static/media/expense.78084533fece8263c54db459df77abe3.svg";
export { ForwardRef as ReactComponent };